import { render, staticRenderFns } from "./coffee-sort.vue?vue&type=template&id=354a3e5c&scoped=true&"
import script from "./coffee-sort.vue?vue&type=script&lang=js&"
export * from "./coffee-sort.vue?vue&type=script&lang=js&"
import style0 from "./coffee-sort.vue?vue&type=style&index=0&id=354a3e5c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354a3e5c",
  null
  
)

export default component.exports